export default function setInputIntercations () {
        const form = document.querySelector('[number-code-form]')
        const inputs = form.querySelectorAll('[number-code-init]')

        function handleInput(e) {
            const numbers = "0123456789"
            const input = e.target
            if (numbers.includes(input.value)) {
                const nextInput = input.nextElementSibling
                if (nextInput && input.value) {
                    nextInput.focus()
                    if (nextInput.value) {
                        nextInput.select()
                    }
                }
            }
            else {
                input.value = ""
            }
        }

        function handlePaste(e) {
            e.preventDefault()
            const paste = e.clipboardData.getData('text')
            let value = ""
            inputs.forEach((input, i) => {
                input.value = paste[i] || ''
                value = input.value
            })
            this.codeValue = value
        }

        function handleBackspace(e) { 
            const input = e.target
            if (input.value) {
                input.value = ''
                return
            }
            
            input.previousElementSibling?.focus()
        }

        function handleArrowLeft(e) {
            const previousInput = e.target.previousElementSibling

            if (!previousInput) return

            previousInput?.focus()
        }

        function handleArrowRight(e) {
            const nextInput = e.target.nextElementSibling

            if (!nextInput) return

            nextInput?.focus()
        }

        form.addEventListener('input', handleInput)
        inputs[0].addEventListener('paste', handlePaste)
        inputs[0].focus()

        inputs.forEach(input => {
            input.addEventListener('focus', e => {
                setTimeout(() => {
                    e.target.select()
                }, 0)
            })
            input.addEventListener('keydown', e => {
                switch(e.key) {
                    case "Backspace":
                        handleBackspace(e)
                        break
                    case "ArrowLeft":
                        handleArrowLeft(e)
                        break
                    case "ArrowRight":
                        handleArrowRight(e)
                        break
                    default: 
                }
            })
        })
}